// Generado por `planta-tool/publicar.py` — NO se edita a mano.
//
// Llave = nombre del archivo en el blob (`Modelos.AzureBlobCroquisBN`).

import type { ModeloPlantaCrudo } from '../tipos';

export const MEDIDOS: Record<string, () => Promise<{ default: ModeloPlantaCrudo }>> = {
  "CroquisBN-419-Toledo-T-3D-2B-WC.pdf": () => import('./croquisbn419ToledoT3d2bWc'),
  "CroquisBN-420-Segovia-T-2D-1-5B-WC.pdf": () => import('./croquisbn420SegoviaT2d15bWc'),
  "CroquisBN-421-Salamanca-T-3D-2-5B-WC.pdf": () => import('./croquisbn421SalamancaT3d25bWc'),
  "CroquisBN-422-Ujue-T-2D-1B-WC.pdf": () => import('./croquisbn422UjueT2d1bWc'),
  "CroquisBN-423-Burgos-T-2D-2B-WC.pdf": () => import('./croquisbn423BurgosT2d2bWc'),
  "CroquisBN-424-Avila-T-3D-2-5-WC-Isla-PB.pdf": () => import('./croquisbn424AvilaT3d25WcIslaPb'),
  "CroquisBN-425-Avila-T-3D-2-5-WC-PB.pdf": () => import('./croquisbn425AvilaT3d25WcPb'),
  "CroquisBN-AD Caspe Az (F).pdf": () => import('./croquisbnAdCaspeAzF'),
  "CroquisBN-AD Neo Tripoli Az (H,I).pdf": () => import('./croquisbnAdNeoTripoliAzHI'),
  "CroquisBN-AD Neo Tripoli T(H,I).pdf": () => import('./croquisbnAdNeoTripoliTHI'),
  "CroquisBN-AdraAzoteaWC.pdf": () => import('./croquisbnAdraazoteawc'),
  "CroquisBN-AdraTechoWC.pdf": () => import('./croquisbnAdratechowc'),
  "CroquisBN-Caspe A 4D 2B Copia.pdf": () => import('./croquisbnCaspeA4d2bCopia'),
  "CroquisBN-Caspe A 4D 2B.pdf": () => import('./croquisbnCaspeA4d2b'),
  "CroquisBN-Caspe A WC.pdf": () => import('./croquisbnCaspeAWc'),
  "CroquisBN-Caspe T 3D 2B OF Copia.pdf": () => import('./croquisbnCaspeT3d2bOfCopia'),
  "CroquisBN-Caspe T WC.pdf": () => import('./croquisbnCaspeTWc'),
  "CroquisBN-CireneT.pdf": () => import('./croquisbnCirenet'),
  "CroquisBN-Estella 1D PA Az Copia Copia.pdf": () => import('./croquisbnEstella1dPaAzCopiaCopia'),
  "CroquisBN-Estella 1D PA Az Copia.pdf": () => import('./croquisbnEstella1dPaAzCopia'),
  "CroquisBN-Estella 1D PA Az.pdf": () => import('./croquisbnEstella1dPaAz'),
  "CroquisBN-Estella.pdf": () => import('./croquisbnEstella'),
  "CroquisBN-Gyrini T 3D 2.5B WC.pdf": () => import('./croquisbnGyriniT3d25bWc'),
  "CroquisBN-Gyro A 3D 2.5B WC.pdf": () => import('./croquisbnGyroA3d25bWc'),
  "CroquisBN-Gyro T 3D 2.5B WC.pdf": () => import('./croquisbnGyroT3d25bWc'),
  "CroquisBN-Kora A 4D 3B WC.pdf": () => import('./croquisbnKoraA4d3bWc'),
  "CroquisBN-Kora T 4D 3B WC.pdf": () => import('./croquisbnKoraT4d3bWc'),
  "CroquisBN-Milo T 1D 1B.pdf": () => import('./croquisbnMiloT1d1b'),
  "CroquisBN-NEO TRIPOLI 6.8 A WC.pdf": () => import('./croquisbnNeoTripoli68AWc'),
  "CroquisBN-NEO TRIPOLI 6.8 WC.pdf": () => import('./croquisbnNeoTripoli68Wc'),
  "CroquisBN-Neo Tripoli A 3D 2B WC.pdf": () => import('./croquisbnNeoTripoliA3d2bWc'),
  "CroquisBN-Neo Tripoli T 3D 2B WC.pdf": () => import('./croquisbnNeoTripoliT3d2bWc'),
  "CroquisBN-SantanderAzoteaWC.pdf": () => import('./croquisbnSantanderazoteawc'),
  "CroquisBN-SantanderTechoWC.pdf": () => import('./croquisbnSantandertechowc'),
  "CroquisBN-SantoriniAWC.pdf": () => import('./croquisbnSantoriniawc'),
  "CroquisBN-SantoriniAzoteaWC.pdf": () => import('./croquisbnSantoriniazoteawc'),
  "CroquisBN-SantoriniTWC.pdf": () => import('./croquisbnSantorinitwc'),
  "CroquisBN-Skyros T 2D 2B WC.pdf": () => import('./croquisbnSkyrosT2d2bWc'),
  "CroquisBN-SkyrosAWC.pdf": () => import('./croquisbnSkyrosawc'),
  "CroquisBN-SkyrosTWC.pdf": () => import('./croquisbnSkyrostwc'),
  "CroquisBN-Stella A 2D 2.5B WC (PAB).pdf": () => import('./croquisbnStellaA2d25bWcPab'),
  "CroquisBN-Stella A 3D 1.5B WC (PA).pdf": () => import('./croquisbnStellaA3d15bWcPa'),
  "CroquisBN-Stella A 4D 3.5B WC L(PAB).pdf": () => import('./croquisbnStellaA4d35bWcLPab'),
  "CroquisBN-Stella T 2D 2.5B WC (PAB).pdf": () => import('./croquisbnStellaT2d25bWcPab'),
  "CroquisBN-Stella T 3D 1.5B WC (PA).pdf": () => import('./croquisbnStellaT3d15bWcPa'),
  "CroquisBN-Stella T 3D 3.5B WC (PA) Copia.pdf": () => import('./croquisbnStellaT3d35bWcPaCopia'),
  "CroquisBN-Stella T 4D 3.5B WC L(PAB).pdf": () => import('./croquisbnStellaT4d35bWcLPab'),
  "CroquisBN-Tebas A.pdf": () => import('./croquisbnTebasA'),
  "CroquisBN-ZafraAWC.pdf": () => import('./croquisbnZafraawc'),
  "CroquisBN-ZafraTWC.pdf": () => import('./croquisbnZafratwc'),
};
